module.exports = __webpack_public_path__ + "img/zrinjski-logo-icon.1b262d7a.png";